import LeftColumn from './LeftColumn';

export default LeftColumn;
